import { render, staticRenderFns } from "./EmployeeDeviceLimitsSettings.vue?vue&type=template&id=6a536834&scoped=true"
import script from "./EmployeeDeviceLimitsSettings.vue?vue&type=script&lang=js"
export * from "./EmployeeDeviceLimitsSettings.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./EmployeeDeviceLimitsSettings.vue?vue&type=style&index=1&id=6a536834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a536834",
  null
  
)

export default component.exports